import React, { useEffect } from 'react';
import { setPageTitle, resetPageTitle } from '../utils/pageTitle';

/**
 * Component to set the page title dynamically
 * @param {Object} props Component props
 * @param {string} props.title Page title to display (will be prefixed with "JuhariTrading - ")
 * @returns {null} This component doesn't render anything
 */
const PageTitle = ({ title }) => {
  useEffect(() => {
    // Set the document title immediately using the utility function
    setPageTitle(title);
    
    // Cleanup function to reset title when component unmounts
    return () => {
      resetPageTitle();
    };
  }, [title]);

  // This component doesn't render anything
  return null;
};

export default PageTitle; 